













import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class RadioSlotBox extends Vue {
  @Prop({ required: false, default: null })
  private value!: any;

  @Prop({ required: false, default: false })
  private disabled!: any;

  @Prop({ required: false, default: null })
  private nativeValue!: any;

  public get isActive() {
    return !this.$_.isNull(this.nativeValue) && this.nativeValue === this.value;
  }
}
